import { Link } from "react-router-dom";
import { imgSrc } from "../../lib/api";
import { useLang, stoneName, stoneDims } from "../../i18n/lang";

export const AvailDot = ({ value, t }) => {
  const c = value === "available" ? "bg-[#5d6b4f]" : value === "reserved" ? "bg-[#b08a4a]" : "bg-[#8a3b2e]";
  return (
    <span className="inline-flex items-center gap-2" data-testid="stone-availability">
      <span className={`w-1.5 h-1.5 rounded-full ${c}`} />{t.avail[value]}
    </span>
  );
};

export const StoneCard = ({ stone, cats = [], frame = "aspect-[3/4]", className = "", index }) => {
  const { t, to, lang } = useLang();
  const cat = cats.find((c) => c.slug === stone.category);
  const catName = cat ? (lang === "it" ? cat.name_it : cat.name_en) : "";
  const dims = stoneDims(stone);
  return (
    <Link to={to(`/stones/${stone.code}`)} className={`group block ${className}`} data-testid={`stone-card-${stone.code}`}>
      <figure className={`relative overflow-hidden bg-[#F0F0F0] ${frame}`}>
        <img src={imgSrc(stone.images?.[0])} alt={`${stoneName(stone, lang)} — ${stone.code}`} loading="lazy"
          className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1600ms] ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-[1.06]" />
        <div className="absolute inset-0 bg-[#1A1A1A]/0 group-hover:bg-[#1A1A1A]/10 transition-colors duration-700" />
        <div className="absolute top-0 inset-x-0 p-4 flex justify-between items-start gap-2">
          <span className="f-mono text-[0.7rem] tracking-[0.12em] bg-[#FFFFFF] text-[#1A1A1A] px-2 py-1">{stone.code}</span>
          {stone.is_demo && <span className="eyebrow !text-[0.62rem] bg-[#1A1A1A] text-[#FFFFFF] px-2 py-1" data-testid="demo-badge">{t.common.example}</span>}
        </div>
        <span className="absolute bottom-4 right-4 eyebrow !text-[0.66rem] bg-[#FFFFFF] text-[#1A1A1A] px-3 py-2 opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-[opacity,transform] duration-500">
          {t.common.viewStone} →
        </span>
      </figure>
      <div className="pt-5 flex items-start justify-between gap-6">
        <div>
          {index !== undefined && <p className="f-mono text-[0.7rem] text-[#555555] mb-2">N° {String(index + 1).padStart(2, "0")}</p>}
          <h3 className="f-serif text-2xl font-light leading-tight">{stoneName(stone, lang)}</h3>
          <p className="mt-2 text-sm text-[#555555]">
            {[catName, t.form[stone.form], dims, stone.finish && t.finishes[stone.finish]].filter(Boolean).join(" · ")}
          </p>
        </div>
        <p className="text-xs text-[#555555] whitespace-nowrap pt-1"><AvailDot value={stone.availability} t={t} /></p>
      </div>
    </Link>
  );
};
